import { render } from "./Events.vue?vue&type=template&id=eaa5ad7c"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"
script.render = render

export default script